module.exports = __webpack_public_path__ + "media/images/products/products/secuirity-ace51ba9cd9143150ed66b0af0b7fb57.jpg";